import React, { Component } from "react";
import {Link} from "react-router-dom";

import './Collections.scss';
import MyContext from '../MyContext.jsx';


class Collections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collections : [],
    }
  }

  componentDidMount(){  
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getDealerCollections`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          collections : return_data.collections
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });

  
    ui.swipeMenu(".schedules_container");
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="collections_page_container noselect">
          <div className="header_spacer"></div>
          <div className="collections_container">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Collections</div>
              <Link className="new_collection_button" to="/collections/new"> 
                <i className="fa fa-plus"></i> New</Link>
            </div>
            <div className="current_month">{new Date().toLocaleString('default', { month: 'long' })} { new Date().getFullYear()}</div>

            <div className="list_blocks_container">
              <div className="lists_container">
                {this.state.collections.map((item,idx)=>(
                  <div className="single_collection_container" key={idx}>
                    <div className="collection_customer_name_delete_button_container">
                      <div className="collection_date_container">
                        <div className="collection_no">{idx+1}</div>
                      </div>
                      <div>
                        <div className="collection_customer_name"><i className="fa fa-user"></i> {item.name}</div>
                        <div className="collection_details_status_button_container">
                          <div>
                            <div className="receipt_no">#{item.receipt_no}</div>
                            <div className="col_date">{new Date(item.col_date).toLocaleDateString()}</div>
                            <div className="amount">{this.context.currency} {item.status == "APT"?item.accept_amount:item.amount}</div>
                          </div>
                          <div style={{display:item.status != "REQ"?"block":"none"}}
                            className={`collection_status status_${item.status ? item.status.toLowerCase() : ""}`}
                          >{item.status == "APT"?'RECEIVED':item.status == "CNL"?'CANCELLED':item.status == "APR"?'APPROVED':item.status == "CANCEL"?'CANCELLED':item.status == "HOLD"?'HOLDED':'' }</div>
                          <Link className="edit_button"
                            to={"/collections/edit/"+item.id}
                            style={{display:item.status == "REQ"?"block":"none"}}
                          >Edit&nbsp;
                            <i className="fa fa-pencil-alt" style={{fontSize: "14px"}}></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}
              </div>
            </div>

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Collections;
Collections.contextType = MyContext;
